import Vue from 'vue';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import VueLoaders from 'vue-loaders';
import moment from 'moment';
import VueToast from 'vue-toast-notification';
// eslint-disable-next-line no-unused-vars
import { loadProgressBar } from 'axios-progress-bar';
import 'axios-progress-bar/dist/nprogress.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-loaders/dist/vue-loaders.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.prototype.$http = axios;
if (window.location.hostname === 'localhost') {
  Vue.prototype.$baseUrl = 'http://localhost:8081';
} else {
  Vue.prototype.$baseUrl = 'https://smart-stewards.herokuapp.com';
}
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueLoaders);
Vue.use(VueToast, {
  position: 'top-right',
});

loadProgressBar();

Vue.filter('formatDate', (value) => {
  const formatted = value ? moment(String(value)).format('DD MMMM YYYY @ HH:mm') : '';
  return formatted;
});

Vue.filter('formatDate2', (value) => {
  const formatted = value ? moment(String(value)).format('DD MMMM YYYY') : '';
  return formatted;
});

const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
  store.dispatch('initAuth');
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
